<script lang="ts">
  import { onMount } from 'svelte';
  import { PdfPreview } from '$provider/models/filePreview/PdfPreview';

  interface Props {
    data: PdfPreview;
  }

  let { data }: Props = $props();

  let pdfViewDiv: HTMLDivElement = $state();

  onMount(() => {
    data?.data && pdfViewDiv.append(...data?.data?.getChildNodes());
  });
</script>

<div class="comp-pdf-view">
  <div class="pdf-view" bind:this={pdfViewDiv}></div>
</div>

<style>
  .pdf-view {
    color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
</style>
